export default __webpack_public_path__ + "static/media/contact_img.e0577b18.png";